/**
 * Dev-only logger. Console statements are stripped in production builds
 * (only `logger.error` is preserved for genuine errors).
 *
 * Usage:
 *   import { logger } from "@/lib/logger";
 *   logger.warn("[shorts] like failed:", err);
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  // Errors always logged so monitoring / Sentry can pick them up
  error: (...args) => { console.error(...args); },
};

export default logger;
